import {
  ACCESSORIES_TAXONOMY_KEY,
  ACCOMMODATIONS_TAXONOMY_KEY,
  ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
  BANDS_DJS_TAXONOMY_KEY,
  BAR_SERVICES_TAXONOMY_KEY,
  BRIDAL_SHOPS_TAXONOMY_KEY,
  CAKES_DESSERTS_TAXONOMY_KEY,
  CATERING_TAXONOMY_KEY,
  CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
  CHILDCARE_SERVICES_TAXONOMY_KEY,
  CLOTHING_RENTALS_TAXONOMY_KEY,
  FLORISTS_TAXONOMY_KEY,
  GENERAL_SERVICES_TAXONOMY_KEY,
  GIFT_FAVORS_TAXONOMY_KEY,
  HAIR_MAKEUP_TAXONOMY_KEY,
  INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
  JEWELERS_TAXONOMY_KEY,
  LIGHTING_AV_TAXONOMY_KEY,
  PHOTOBOOTHS_TAXONOMY_KEY,
  PHOTOGRAPHERS_TAXONOMY_KEY,
  PLANNERS_TAXONOMY_KEY,
  RENTALS_DECOR_TAXONOMY_KEY,
  SERVICE_STAFF_TAXONOMY_KEY,
  TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
  VARIETY_ACTS_TAXONOMY_KEY,
  VENUES_TAXONOMY_KEY,
  VIDEOGRAPHERS_TAXONOMY_KEY,
  VendorTaxonomyKey,
} from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorTaxonomySwitchFunc } from '@zola-helpers/client/dist/es/marketplace/vendorUtils';

import Accessories from '../assets/images/iconsRebrand/accessories.svg';
import Venue from '../assets/images/iconsRebrand/agnostic_venue.svg';
import Alterations from '../assets/images/iconsRebrand/alterations.svg';
import Balloons from '../assets/images/iconsRebrand/balloons.svg';
import Band from '../assets/images/iconsRebrand/band.svg';
import GiftPile from '../assets/images/iconsRebrand/bonus_gifts.svg';
import Bouquet from '../assets/images/iconsRebrand/bouquet.svg';
import Photographer from '../assets/images/iconsRebrand/camera.svg';
import ChampagneGlasses from '../assets/images/iconsRebrand/champagne_glasses.svg';
import Planner from '../assets/images/iconsRebrand/checklist.svg';
import Childcare from '../assets/images/iconsRebrand/childcare_services.svg';
import GiftableJewelry from '../assets/images/iconsRebrand/giftable_jewelry.svg';
import Beauty from '../assets/images/iconsRebrand/hair_makeup.svg';
import Hotel from '../assets/images/iconsRebrand/hotel.svg';
import Transportation from '../assets/images/iconsRebrand/just_married.svg';
import PlaceSetting from '../assets/images/iconsRebrand/place_setting.svg';
import ServiceStaff from '../assets/images/iconsRebrand/service_staff.svg';
import VeilsAccessories from '../assets/images/iconsRebrand/veils_accessories.svg';
import Videographer from '../assets/images/iconsRebrand/video_camera.svg';
import Cakes from '../assets/images/iconsRebrand/wedding_cake.svg';
import TwoCircles from '../assets/images/iconsRebrand/wedding_rings.svg';
import WomensShoes from '../assets/images/iconsRebrand/womens_shoes.svg';
import WorshipVenue from '../assets/images/iconsRebrand/worship_venue.svg';

export const getVendorIcon = (vendorTaxonomyKey?: VendorTaxonomyKey | 'all'): string => {
  if (!vendorTaxonomyKey || vendorTaxonomyKey === 'all') {
    return TwoCircles;
  }

  return getVendorTaxonomySwitchFunc({
    [ACCESSORIES_TAXONOMY_KEY]: Accessories,
    [ACCOMMODATIONS_TAXONOMY_KEY]: Hotel,
    [ALTERATIONS_PRESERVATION_TAXONOMY_KEY]: Alterations,
    [BANDS_DJS_TAXONOMY_KEY]: Band,
    [BAR_SERVICES_TAXONOMY_KEY]: ChampagneGlasses,
    [BRIDAL_SHOPS_TAXONOMY_KEY]: VeilsAccessories,
    [CAKES_DESSERTS_TAXONOMY_KEY]: Cakes,
    [CATERING_TAXONOMY_KEY]: PlaceSetting,
    [CELEBRANTS_OFFICIANTS_TAXONOMY_KEY]: WorshipVenue,
    [CHILDCARE_SERVICES_TAXONOMY_KEY]: Childcare,
    [CLOTHING_RENTALS_TAXONOMY_KEY]: WomensShoes,
    [FLORISTS_TAXONOMY_KEY]: Bouquet,
    [GENERAL_SERVICES_TAXONOMY_KEY]: TwoCircles,
    [GIFT_FAVORS_TAXONOMY_KEY]: GiftPile,
    [HAIR_MAKEUP_TAXONOMY_KEY]: Beauty,
    [INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY]: TwoCircles,
    [JEWELERS_TAXONOMY_KEY]: GiftableJewelry,
    [LIGHTING_AV_TAXONOMY_KEY]: TwoCircles,
    [PHOTOBOOTHS_TAXONOMY_KEY]: TwoCircles,
    [PHOTOGRAPHERS_TAXONOMY_KEY]: Photographer,
    [PLANNERS_TAXONOMY_KEY]: Planner,
    [RENTALS_DECOR_TAXONOMY_KEY]: Balloons,
    [SERVICE_STAFF_TAXONOMY_KEY]: ServiceStaff,
    [TRANSPORTATION_PROVIDERS_TAXONOMY_KEY]: Transportation,
    [VARIETY_ACTS_TAXONOMY_KEY]: TwoCircles,
    [VENUES_TAXONOMY_KEY]: Venue,
    [VIDEOGRAPHERS_TAXONOMY_KEY]: Videographer,
  })(vendorTaxonomyKey);
};

export default getVendorIcon;
